import Login from '../../components/login';

const LoginPage = () => {
  return <Login></Login>;
};

export default LoginPage;
